import { StakingProvider } from '@trustpad/launchpad/dist/staking/hooks/useStaking';

import * as React from 'react';

import { stakingPools } from '~config/stakingPoolsConfig';
import { StakingCard } from '~features/staking/components/StakingCard';
import { StakingLPCard } from '~features/staking/components/StakingLPCard';

export function StakingPage({ legacy }: { legacy?: boolean }) {
  const pools = stakingPools.filter(
    (p) => p.deprecated === !!legacy && !p.hidden,
  );

  return (
    <div className="space-y-6">
      {pools.map((pool) => (
        <StakingProvider key={pool.address} pool={pool} onTVLChange={() => {}}>
          {!legacy && Array.isArray(pool.stakeToken) ? (
            <StakingLPCard />
          ) : (
            <StakingCard />
          )}
        </StakingProvider>
      ))}
    </div>
  );
}
